import Vue from 'vue'
import schemeApi from '@/api/scheme.api'
import schemeUserApi from '@/api/schemeUser.api'

const state = {
  schemes: {}
}


const getters = {
  schemeById: (state) => (id) => {
    return state.schemes[id]
  },

  schemes: (state) => {
    return Object.values(state.schemes) || []
  }
}


const actions = {
  async loadSchemes ({ commit, rootState }) {
    const response = await schemeApi.getSchemes(rootState.tenant.current)
    commit('SET_SCHEMES', response.data)
  },

  async loadRelations ({ commit, rootState }, schemeId) {
    const response = await schemeApi.getRelations(rootState.tenant.current, schemeId)
    return response.data
  },

  async createScheme ({ commit, rootState }, scheme) {
    const response = await schemeApi.createScheme(rootState.tenant.current, scheme)
    commit('CREATE_SCHEME', response.data)
  },

  async updateScheme ({ commit, rootState }, scheme) {
    const response = await schemeApi.updateScheme(rootState.tenant.current, scheme.id, scheme)
    commit('UPDATE_SCHEME', response.data)
  },

  async deleteScheme ({ commit, rootState }, { id }) {
    await schemeApi.deleteScheme(rootState.tenant.current, id)
    commit('DELETE_SCHEME', id)
  },


  async loadSchemeUsers ({ commit, rootState }, schemeId) {
    const response = await schemeUserApi.getSchemeUsers(rootState.tenant.current, schemeId)
    const schemeUsers = response.data
    commit('SET_SCHEME_USERS', { schemeId, schemeUsers })
  },

  async loadSchemeUser ({ commit, rootState }, { schemeId, userId }) {
    const response = await schemeUserApi.getSchemeUser(rootState.tenant.current, schemeId, userId)
    commit('SET_SCHEME_USER', { schemeId, schemeUser: response.data })
  },

  async updateSchemeUser ({ commit, rootState }, { schemeId, schemeUser }) {
    const response = await schemeUserApi.updateSchemeUser(rootState.tenant.current, schemeId, schemeUser.userId, schemeUser)
    commit('UPDATE_SCHEME_USER', { schemeId, schemeUser: response.data })
  }
}


const mutations = {
  SET_SCHEMES (state, schemes) {
    state.schemes = {}
    for (const scheme of schemes) {
      Vue.set(state.schemes, scheme.id, scheme)
    }
  },

  CREATE_SCHEME (state, scheme) {
    Vue.set(state.schemes, scheme.id, scheme)
  },

  UPDATE_SCHEME (state, scheme) {
    Vue.set(state.schemes, scheme.id, scheme)
  },

  DELETE_SCHEME (state, id) {
    Vue.delete(state.schemes, id)
  },

  SET_SCHEME_USERS (state, { schemeId, schemeUsers }) {
    state.schemes[schemeId].users = [...schemeUsers]
  },


  SET_SCHEME_USER (state, { schemeId, schemeUser }) {
    const _schemeUser = state.schemes[schemeId].users.find(x => x.userId === schemeUser.userId)

    if (!_schemeUser) {
      state.schemes[schemeId].users.push(schemeUser)
    } else {
      _schemeUser.contractClaim = schemeUser.contractClaim
      _schemeUser.budgetClaim = schemeUser.budgetClaim
      _schemeUser.todoClaim = schemeUser.todoClaim
      _schemeUser.eventClaim = schemeUser.eventClaim
      _schemeUser.documentClaim = schemeUser.documentClaim
    }
  },

  UPDATE_SCHEME_USER (state, { schemeId, schemeUser }) {
    const _schemeUser = state.schemes[schemeId].users.find(x => x.userId === schemeUser.userId)

    _schemeUser.contractClaim = schemeUser.contractClaim
    _schemeUser.budgetClaim = schemeUser.budgetClaim
    _schemeUser.todoClaim = schemeUser.todoClaim
    _schemeUser.eventClaim = schemeUser.eventClaim
    _schemeUser.documentClaim = schemeUser.documentClaim
  }
}


export default {
  state,
  getters,
  actions,
  mutations
}
